// extracted by mini-css-extract-plugin
export default {"hiddenPlaceholder":"Milestone-module__hiddenPlaceholder__lFLrl2A"};